import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import { Box } from '@mui/material'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'
import GoogleAddressInput from '../../../components/atoms/input/GoogleAddressInput'

function VenueAddress({
	open,
	handleClose,
	handleNext,
	handleBack,
	type,
	weddingData,
	setWeddingData,
}) {
	const handlePlaceSelected = (placeData) => {
		setWeddingData((prev) => ({
			...prev,
			[type === 'Ceremony' ? 'ceremonyVenue' : 'receptionVenue']:
				placeData.formattedAddress,
		}))
	}

	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>Tell us where your wedding will be held.</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<Box className={styles.formInputs}>
								<GoogleAddressInput
									data-cy="Wedding Name"
									placeholder={`${type} venue address`}
									name={
										type === 'Ceremony'
											? 'ceremonyVenue'
											: 'receptionVenue'
									}
									value={
										type === 'Ceremony'
											? weddingData.ceremonyVenue
											: weddingData.receptionVenue
									}
									setDataFunction={setWeddingData}
									data={weddingData}
									onPlaceSelected={handlePlaceSelected}
									required={true}
								/>
							</Box>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={() => {
                        if(type === 'Ceremony' && weddingData?.ceremonyVenue ||
                            type === 'Reception' && weddingData?.receptionVenue
                        ){
                            return handleNext(weddingData.reception ? 2 : 5)
                        }
                        toastHelper('Invalid address', 'error')
					}}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper
						activeStep={
							type === 'Ceremony' && weddingData?.ceremonyVenue
								? 1.99
								: type === 'Reception' && weddingData?.receptionVenue
									? 2.2
									: 2.2
						}
					/>
				</div>
			</div>
		</NewWedingModal>
	)
}

export default VenueAddress
